import {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {CardBody, CardFooter, CardText, CardTitle} from 'reactstrap'

import Date from '../../../../shared/components/Moment/Date.jsx'
import FrontCard from '../FrontCard.jsx'
import SearchCard from '../SearchCard.jsx'

import './PurchaserSearchCard.scss'

export default class PurchaserSearchCard extends PureComponent {
  static propTypes = {
    generateLink: PropTypes.func.isRequired,
    offset: PropTypes.number.isRequired,
    score: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),//false => no data
    user: PropTypes.shape({
      id: PropTypes.number.isRequired,
    }).isRequired,
  }

  render() {
    const {user, ...props} = this.props

    return <SearchCard className="purchaser-search-card" link={this.props.generateLink(user, props.offset)}>
      <FrontCard score={props.score}>
        <CardBody>
          <CardTitle>{(user?.fullname ?? '').trim() === '' ? '???' : user.fullname}</CardTitle>
          <CardText tag="div">
            <p>{user?.fonction ?? ''}</p>
            {user.company ? <p>@{user.company}</p> : ''}
            <p>{user.email}</p>
            <p>{user.tel}</p>
          </CardText>
        </CardBody>
        <CardFooter>
          <span>Inscrit le <Date date={user.date_created}/></span>
          <span>#{user.id}</span>
        </CardFooter>
      </FrontCard>
    </SearchCard>
  }
}
